// extracted by mini-css-extract-plugin
module.exports = {"upgrade":"_D","upgradeHide":"_E"};